import React from 'react';
import Paper from '@mui/material/Paper';

function Card({ children, sx, ...rest }) {
  return (
    <Paper
      elevation={0}
      sx={{
        p: '22px',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        boxShadow: '0px 5px 14px rgba(0, 0, 0, 0.05)',
        borderRadius: '20px',
        position: 'relative',
        wordWrap: 'break-word',
        backgroundColor: '#ffffff',
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Paper>
  );
}

export default Card;
